import { createStore, Store } from '@solinkcorp/store';

class AiChatStore extends Store {
  initialize() {}
  isOpen = false;
  isMaximized = false;

  minimize() {
    this.isMaximized = false;
  }

  close() {
    this.isOpen = false;
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
  }

  toggleMaximize() {
    this.isMaximized = !this.isMaximized;
  }
}

export const { Provider: AiChatStoreProvider, useStore: useAiChatStore } = createStore(AiChatStore);
